import React from 'react';
import { connect } from 'react-redux';
import { openDialog } from 'common/actions';
import * as DialogTypes from 'common/dialog-types';
import HighlightsProp from 'common/prop-types/highlights';
import HighlightsTab from 'components/shared/profile-tabs/highlights/highlights-tab';
import ProfileType from 'common/container-subtype';

class AuthorHighlightsTab extends React.Component {
  static propTypes = {
    dispatch: React.PropTypes.func,
    highlights: HighlightsProp,
    isMobile: React.PropTypes.bool.isRequired,
  }

  getPrivacyMessage() {
    return;
  }

  getCreateHighlightMessage() {
    return;
  }

  getNoHighlightsMessage() {
    return;
  }

  onShareVideoClick(id, title, url, tweetText) {
    this.props.dispatch(openDialog(
      DialogTypes.SHARE_VIDEO_DIALOG,
      {
        id,
        title,
        url,
        tweetText,
        type: 'Highlight',
      }));
  }

  render() {
    return (
      <HighlightsTab
        profileType={ProfileType.Author}
        dispatch={this.props.dispatch}
        forcePublicView={false}
        highlights={this.props.highlights}
        highlightsArePrivate={false}
        userCanAccessPrivate
        isPrivilegedUser={false}
        isMobile={this.props.isMobile}
        getPrivacyMessage={this.getPrivacyMessage.bind(this)}
        getCreateHighlightMessage={this.getCreateHighlightMessage.bind(this)}
        getNoHighlightsMessage={this.getNoHighlightsMessage.bind(this)}
        onShareVideoClick={this.onShareVideoClick.bind(this)}
      />
    );
  }
}

function select(state) {
  return state;
}

export default connect(select)(AuthorHighlightsTab);
